import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private translateService = inject(TranslateService);
  private langSubject = new BehaviorSubject<string>(localStorage.getItem('lang') || 'vi');
  public lang$ = this.langSubject.asObservable();

  constructor() {
    window.addEventListener('storage', event => {
      if (event.key === 'lang') {
        const newLang = event.newValue || 'vi';
        this.langSubject.next(newLang);
        this.translateService.use(newLang);
      }
    });
  }

  setLanguage(lang: string) {
    localStorage.setItem('lang', lang);
    this.langSubject.next(lang);
    this.translateService.use(lang);
  }

  getCurrentLanguage(): string {
    return this.langSubject.value;
  }
}
